export const PRODUIT_LOCATION_REFERENCE_NUM_FULL = 'FULLNat1Semaine';
export const PRODUIT_LOCATION_REFERENCE_NUM_ACCESS = 'ACCESSNat1Semaine';
export const PRODUIT_LOCATION_REFERENCE_NUM_FULL_UNITE = 'FULL1Unite';
export const TYPE_PIECE_JOINTE_IMPORT_NUM_LIBELLE = 'Import numérique';
